import React from "react";
import { INVENTORY } from "../../data/mockData";

export default function Inventory() {
  const low      = INVENTORY.filter(i => i.status === "low").length;
  const critical = INVENTORY.filter(i => i.status === "critical").length;

  return (<>
    <div className="g3" style={{ marginBottom:16 }}>
      {[["📦","Total Items",INVENTORY.length,false],["⚠️","Low Stock",low,low>0],["🚨","Critical",critical,critical>0]].map(([ic,lb,v,warn]) => (
        <div className="stat" key={lb}>
          <div className="stat-icon">{ic}</div>
          <div className="stat-val">{v}</div>
          <div className="stat-lbl">{lb}</div>
          <div className={`stat-sub ${warn?"stat-warn":""}`}>{warn ? "Needs immediate action" : "All categories"}</div>
        </div>
      ))}
    </div>

    <div className="panel">
      <div className="panel-hd">
        <span className="panel-hd-title">Stock Levels</span>
        <button className="btn-gold" style={{ padding:"7px 14px", fontSize:10 }}>+ Add Item</button>
      </div>
      <div style={{ overflowX:"auto" }}>
        <table className="tbl">
          <thead>
            <tr><th>Item</th><th>Category</th><th>In Stock</th><th>Min Level</th><th>Level</th><th>Status</th><th>Action</th></tr>
          </thead>
          <tbody>
            {INVENTORY.map(inv => {
              const pct = Math.min(100, Math.round((inv.stock / inv.minStock) * 100));
              const barColor = inv.status === "critical" ? "#e74c3c" : inv.status === "low" ? "#c8a05a" : "#4a7c59";
              return (
                <tr key={inv.id}>
                  <td style={{ fontWeight:400 }}>{inv.item}</td>
                  <td><span className="badge badge-gray">{inv.category}</span></td>
                  <td style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:16 }}>
                    {inv.stock} <span style={{ fontSize:10, color:"#8a7060" }}>{inv.unit}</span>
                  </td>
                  <td style={{ color:"#8a7060", fontSize:12 }}>{inv.minStock} {inv.unit}</td>
                  <td style={{ width:120 }}>
                    <div className="prog-wrap">
                      <div className="prog-fill" style={{ width:`${pct}%`, background:barColor }}/>
                    </div>
                  </td>
                  <td>
                    <span className={`badge ${inv.status==="ok"?"badge-green":inv.status==="low"?"badge-gold":"badge-red"}`}>
                      {inv.status}
                    </span>
                  </td>
                  <td><button className="btn-outline" style={{ padding:"5px 12px", fontSize:10 }}>Restock</button></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  </>);
}
